const topics = [
  { label: '#顶流塌房', count: '3.2万讨论', hot: true },
  { label: '#明星解约', count: '2.8万讨论', hot: true },
  { label: '#网红翻车', count: '2.5万讨论', hot: true },
  { label: '#社会黑幕', count: '2.1万讨论', hot: false },
  { label: '#科技造假', count: '1.9万讨论', hot: false },
  { label: '#直播内幕', count: '1.7万讨论', hot: false },
  { label: '#体育黑哨', count: '1.5万讨论', hot: false },
  { label: '#金融诈骗', count: '1.3万讨论', hot: false },
  { label: '#食品安全', count: '1.2万讨论', hot: false },
  { label: '#影视潜规则', count: '1.1万讨论', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-900 mb-3">热门话题</h2>
          <p className="text-foreground-500 text-sm max-w-xl mx-auto">当前最受关注的黑料话题标签，看看大家都在讨论什么</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-4xl mx-auto">
          {topics.map((topic, i) => (
            <a
              key={i}
              href="#index"
              className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full border transition-all duration-200 cursor-pointer no-underline ${
                topic.hot
                  ? 'bg-primary-50 border-primary-200/60 hover:bg-primary-100'
                  : 'bg-background-50 border-background-200/60 hover:border-primary-200/60 hover:bg-background-50'
              }`}
            >
              <span
                className={`text-sm font-semibold ${
                  topic.hot ? 'text-primary-600' : 'text-foreground-700 group-hover:text-primary-500'
                } transition-colors`}
              >
                {topic.label}
              </span>
              <span className="text-xs text-foreground-400">{topic.count}</span>
              {topic.hot && (
                <span className="flex items-center gap-0.5 text-xs text-accent-500 font-medium">
                  <i className="ri-fire-line" />
                </span>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}